import { useEffect, useState} from 'react';

import axios from 'axios';

const useFetchData = ({orderid, setLoading}) => {
  const [data, setData] = useState({});
  

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const { data: response } = await axios.get(`https://bulkify.in/api/vendor/order-details.php?orderid=${orderid}`);
        setData(response);
      } catch (error) {
        console.error(error)
      }
      finally{
        setLoading(false);
      }
      
    };

    fetchData();
  }, [orderid, setLoading]);

  return {data};
};

export default useFetchData;
